// eslint-disable @typescript-eslint/no-this-alias

import * as _ from "lodash";
import {
    IObjectTree,
    IObjectTreeCreateLoadOptions,
    IObjectTreeLogicalKey,
    IObjectTreeManager
} from "../PA.Core.IF.ObjectTree";
import { PAdbContext } from "../PAdbContext";
import { ESRecordResolver } from "../lib/ESRecordResolver";
import { esWB_Company, esWB_MasterData_Set, esWB_SalesOrg, esWB_Tree, esWB_Tree_Folder } from "../PAdbSchema";
import { WB_TreeRow } from "../PAdbSchemaRows";
import { ObjectTree } from "./ObjectTree";


export class ObjectTreeManager
implements IObjectTreeManager
{

    async find(options: IObjectTreeCreateLoadOptions): Promise<IObjectTree> {

        let dbContext = options?.dbContext
        if(_.isEmpty(dbContext))
            dbContext = new PAdbContext()

        let rr = new ESRecordResolver(dbContext, {
            standardConditions: {
                [esWB_Tree_Folder]: {"DELETED_IND": {"notIn": ['1']}},
            }
        })
        let lkCnd = this.createCnd(options)
        lkCnd.DELETED_IND = {"notIn": ['1']}

        let recs = <WB_TreeRow[]> await rr.queryAllWithRelationships(esWB_Tree, {where: lkCnd})

        if(_.isEmpty(recs))
            return undefined

        return new ObjectTree(recs[0], {bSkipRecordResolution: true,
                                                objectTreeContentProvider: options?.objectTreeDataManager})

    }

    private createCnd(key: IObjectTreeLogicalKey): any {
        let lkCnd: any = {
            SOURCE_TYPE: key.sourceType || '',
            SOURCE_WB_ID: key.sourceWbId || 0,
            WB_MDSET_ID: key.wbMasterDataSetId || 0,
            WB_COMPANY_ID: key.wbCompanyId || 0,
            WB_SALESORG_ID: key.wbSalesOrgId || 0,
            USER_IND: '0'
        }

        let wbAuthUsrId = key.wbAuthUsrId || 0
        if(wbAuthUsrId > 0){
            lkCnd.USER_IND = '1'
            lkCnd.WB_AUTHUSR_ID = wbAuthUsrId
        }
        return lkCnd
    }

    async findOrCreate(options: IObjectTreeCreateLoadOptions): Promise<IObjectTree> {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this

        let opts: IObjectTreeCreateLoadOptions = _.clone(options) || {}

        let dbContext = opts?.dbContext
        if(_.isEmpty(dbContext)) {
            dbContext = new PAdbContext()
            opts.dbContext = dbContext
        }

        let f = await self.find(opts)

        if(!_.isEmpty(f))
            return f

        // Create record
        let lkFields = self.createCnd(options)

        let newRec = <WB_TreeRow> await dbContext.createRecordWithKey(esWB_Tree)
        let tr = newRec.cif

        tr.TREE_NAME = options.treeName || 'Tree'
        tr.WB_AUTHUSR_ID = 0
        // set Key Fields
        _.forEach(lkFields, (value, key) => {
            tr[key] = value
        })

        await newRec.loadRelations([esWB_MasterData_Set, esWB_SalesOrg, esWB_Company])
        await dbContext.Save(esWB_Tree, newRec)

        let n = new ObjectTree(newRec,
            {bSkipRecordResolution: true,
                    objectTreeContentProvider: options?.objectTreeDataManager})

        return n
    }

}


